import { FC } from 'react';
import { useOnsiteCampaignUrlParams } from 'sections/onsite-campaigns/hooks/useOnsiteCampaignUrlParams';
import { ImageArea } from '@salecycle/ui-component-library';

export interface OnsiteTemplateThumbnailProps {
  templateId: string;
  supportedLanguage: string;
  channel: string;
}

export const OnsiteTemplateThumbnail: FC<OnsiteTemplateThumbnailProps> = ({
  templateId,
  supportedLanguage,
  channel,
}) => {
  const { siteId } = useOnsiteCampaignUrlParams();

  const src =
    channel === 'onsite'
      ? `${
          import.meta.env.VITE_TEMPLATE_THUMBNAIL_URL
        }/sites/${siteId}/onsite/${templateId}/${supportedLanguage}.html.jpg`
      : `${
          import.meta.env.VITE_TEMPLATE_THUMBNAIL_URL
        }/sites/${siteId}/${templateId}/${supportedLanguage}.template.jpg`;

  const fallback = '/images/designs/design_gallery/default_template_placeholder_small.png';

  return <ImageArea height={100} width={100} src={src} fallback={fallback} />;
};
